import {
    Variable,
    SquareCode,
    SquareFunction,
    Repeat,
    Braces,
} from "lucide-react";

export const courses = [
  {
    id: 1,
    title: 'Programming',
    href: 'py01',
    description: '',
    date: 'Mar 16, 2020',
    datetime: '2020-03-16',
    icon: SquareCode,
  },
  {
    id: 2,
    title: 'Variables',
    href: 'py02',
    description: 'Variables are containers for storing data values',
    date: 'Mar 10, 2020',
    datetime: '2020-03-10',
    icon: Variable,
  },
  {
    id: 3,
    title: 'Conditions and Loops',
    href: 'py03',
    description: 'If Statements, For, While and Nested Loops',
    date: 'Feb 12, 2020',
    datetime: '2020-02-12',
    icon: Repeat,
  },
  {
    id: 4,
    title: 'Functions',
    href: 'py04',
    description: 'Block of code which only runs when it is called',
    date: 'Feb 12, 2020',
    datetime: '2020-02-12',
    icon: SquareFunction,
  },
  {
    id: 5,
    title: 'Classes and Objects',
    href: 'py05',
    description: 'Python is an object oriented programming language. Almost everything in Python is an object, with its properties and methods.A Class is like an object constructor, or a "blueprint" for creating objects.',
    date: 'Feb 12, 2020',
    datetime: '2020-02-12',
    icon: Braces,
  },
];
